module.exports = __webpack_public_path__ + "static/img/nuevos_02.b2c494fc.jpg";